import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AssigneesSelector from 'modules/shift_management/components/ShiftManagement/AssigneesSelector'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type CommonSelectorsForm from 'modules/shift_management/lib/forms/CommonSelectorsForm'

import SelectedCellsInfo from './SelectedCellsInfo'

interface Props {
  form: CommonSelectorsForm
  selectableEmployeeIds: number[]
  selectedEmployees: number[]
  canReassignShifts?: boolean
  edit?: boolean
  fromLeave?: boolean
  canAdjustSelectedDates?: boolean
}

const EmployeesSection = ({
  form,
  selectableEmployeeIds,
  selectedEmployees,
  canReassignShifts = false,
  edit = false,
  fromLeave = false,
}: Props) => {
  const [{ view }] = useSchedule()
  const { isEnabled: hasSelection } = useSelectionState()

  const showSelector = view.isByEmployees || (view.isByAreas && edit) ? canReassignShifts : true

  const showDates = !fromLeave || (!!fromLeave && !view.isWeekly)

  return (
    <Box gap="s16">
      {hasSelection && !canReassignShifts && (
        <SelectedCellsInfo employeeIds={selectedEmployees} showDates={showDates} />
      )}
      {!fromLeave && (!hasSelection || showSelector) && (
        <AssigneesSelector form={form} selectableEmployeeIds={selectableEmployeeIds} />
      )}
    </Box>
  )
}

export default observer(EmployeesSection)
